import React from 'react';
import './PDFDialog.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";


class PDFDialog extends React.Component {
  state = {
    dispaly:false,
    bloburl:null,
    props:null,
  }
  prevPdf = null;

  close = () => {
    this.setState({
      display:false,
      props: null,
    });
  }

  open = (pdf, props) => {
    if (pdf !== this.prevPdf) {
      window.URL.revokeObjectURL(this.state.bloburl);
      this.prevPdf = pdf;
      this.setState({
        display:true,
        bloburl : window.URL.createObjectURL(pdf),
        props: props
      });
    }
    else {
      this.setState({
        display:true,
        props: props
      });
    }
  }

  render () {
    let windowStyle = {};
    if (this.state.props && this.state.props.size) windowStyle = {width: this.state.props.size.width, height: this.state.props.size.height};

    return (<div className="PDFDialog" style={{display:this.state.display?'block':'none'}}>
      <div className="window" style={windowStyle}>
        <div className="header">
          <FontAwesomeIcon className="closeBtn" icon={faTimes} onClick={this.close}/>
          <span className="title">{this.state.props && this.state.props.title ? this.state.props.title : ''}</span>
        </div>
        <embed src={this.state.bloburl}></embed>
      </div>
    </div>);
  }
}
export default PDFDialog;